const formatCurrency = function(form) {
	const currencyFields = form.element.querySelectorAll('[data-field-type="currency"]');
	if (!currencyFields || currencyFields.length < 1) return;

	currencyFields.forEach(field => {
		field.addEventListener('blur', () => {
			if (isNaN(field.value)) return;
			field.value = parseFloat(field.value).toFixed(2);
		});
	});
};

export default formatCurrency;